/* eslint-disable consistent-return */
/* eslint-disable max-nested-callbacks */
import QualityChart from 'components/echart/QualityChart'
import { flatten, groupBy, max, maxBy, minBy, orderBy, round, sumBy, uniqBy, keys, mean, isUndefined, isNil, compact, template, uniq, keyBy, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { nbPerPageLabel } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { calculateAverage, REMARK_CODES, searchMaxAnalysis, searchP90Analysis } from 'utils/AnalyseUtils'
import { getBeginingOfTheYear, getDate, getYear } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { getLabel } from 'utils/StoreUtils'
import TooltipAnalyse from 'quality/components/qualityComponents/TooltipAnalyse'
import { Card, CardContent, Grid, IconButton, Icon, Tooltip, Dialog, DialogActions, DialogContent, Button, Stack, Box } from '@mui/material'
import IAEauAction from 'iaeau/IAEauAction'
import { HYPE_TRENDS_CONSTANTS } from 'quality/constants/QualityConstants'
import { formatHypeTrend, formatHypeTrendRupture } from 'utils/HypeUtils'
import { exportFile } from 'utils/ExportDataUtil'
import MessageCard from 'components/card/MessageCard'
import ProgressCard from 'components/card/ProgressCard'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import AnalysisAction from 'quality/actions/AnalysisAction'
import DtoAnalysisLight from 'quality/dto/analyse/DtoAnalysisLight'
import DtoQualityThreshold from 'quality/dto/QualityThreshold/DtoQualityThreshold'
import { CardTitle } from 'components/card/NewCard'
import { ALIGN, NewTable } from 'components/datatable/NewTable'
import { calculateThresholdsResult, compareToThreshold, THRESHOLD_COLOR, THRESHOLD_DISCRIMINANT, THRESHOLD_DISPLAY, THRESHOLD_TYPE } from 'utils/QualityThresholdUtils'
import { THRESHOLD } from 'quality/constants/QualityConstants'
import { CheckBox, CheckBoxOutlineBlank, HelpRounded, Visibility, VisibilityOff } from '@mui/icons-material'
import { CardTable } from 'components/datatable/NewTable'
import { blackColor, THRESHOLD_COLORS_CODES, favOrange } from 'utils/constants/ColorTheme'
import { getSettingBool } from 'utils/SettingUtils'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import useBoolean from 'utils/customHook/useBoolean'
import { filterIcon } from 'components/echart/EChartUtils'
import { DEFAULT_THRESHOLD_PESTICIDES_1, DEFAULT_THRESHOLD_PESTICIDES_2, DEFAULT_OBJECTIVE, SUM_PESTICIDES_LABO, DEFAULT_THRESHOLD_IRRELEVANT_PESTICIDES } from 'catchment/constants/CatchmentConstant'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import SliderPanel from 'components/slider/SliderPanel'
import ColorConstant from 'components/constants/ColorConstant'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import { SHOW_SANDRE_CODE, SHOW_INSEE_CODE } from 'account/constants/AccountSettingsConstants'
import ObjectiveChart from 'catchment/components/catchment/dashboard/CatchmentObjectives'
import DtoQualitometerLight from 'quality/dto/DtoQualitometerLight'
import { QualityThresholdType } from 'quality/shapes/QualityThresholdShapes'
import { PesticidesChartAnnualEvolution } from 'catchment/components/catchment/dashboard/CatchmentAnnualEvolution'
import RelevanceChart from './RelevanceChart'
import FrequencyPesticides from './FrequencyPesticides'
import { PieFamilyPesticides } from 'catchment/components/CatchmentsCompare/GraphicCompare'
import AnnualDistributionGraph from './AnnualDistributionGraph'

const THRESHOLD_S1 = 'CATCHMENT_PESTICIDES_DISTRIBUTION_THRESHOLD_1'
const THRESHOLD_S2 = 'CATCHMENT_SUM_PESTICIDES_DISTRIBUTION_THRESHOLD_1'
const THRESHOLD_S3 = 'CATCHMENT_PESTICIDES_DISTRIBUTION_THRESHOLD_2'
const THRESHOLD_S4 = 'CATCHMENT_SUM_PESTICIDES_DISTRIBUTION_THRESHOLD_2'

const getThresholdColor = (value, threshold1, threshold2) => {
    if (isNil(threshold1) && isNil(threshold2) || isNil(value)) return
    if (compareToThreshold(value, threshold2, THRESHOLD_DISCRIMINANT.SUP_OR_EQUAL)) {
        return THRESHOLD_COLOR.red
    }
    if (compareToThreshold(value, threshold1, THRESHOLD_DISCRIMINANT.SUP_OR_EQUAL)) {
        return THRESHOLD_COLOR.orange
    }
    return THRESHOLD_COLOR.green
}

const getTooltip = (substance, analyse, threshold1, threshold2, showCode = true) => {
    if (!substance) return {}
    return {
        tooltip: (
            <TooltipAnalyse
                title={substance}
                analyse={analyse}
                threshold={{
                    parameterCode: showCode ? analyse.parameter : undefined,
                    threshold1,
                    threshold2,
                    thresholdType: THRESHOLD_TYPE.INCREASING,
                    display: THRESHOLD_DISPLAY.INCREASING,
                    discriminant: THRESHOLD_DISCRIMINANT.SUP_OR_EQUAL,
                }}
                overrideColors={[THRESHOLD_COLOR.green, THRESHOLD_COLOR.orange, THRESHOLD_COLOR.red]}
            />
        ),
    }
}

const FollowUpPesticidesTable = ({
    pesticidesAnalysis = [],
    listSumPesticides = [],
    threshold1,
    threshold2,
}) => {
    const {
        qualitometers,
        parameters,
        cities,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        parameters: store.ParameterReducer.parameters,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const pesticidesAnalysisGroup = useMemo(() => {
        return groupBy(pesticidesAnalysis, STATION_TYPE_NAME.qualitometer)
    }, [pesticidesAnalysis])

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const analysisFormated = useMemo(() => {
        const formated = keys(pesticidesAnalysisGroup).map(key => {
            const qualitometer = qualitometers.find(q => q.id === parseInt(key))
            const city = qualitometer && cities.find(c => c.code === qualitometer.townCode)
            const stationName = [qualitometer?.code ? `[${qualitometer.code}]` : '', `${qualitometer?.name || ''}`, `${city?.name ? `- ${city.name}` : ''}`].join(' ')
            const yearGroup = groupBy(pesticidesAnalysisGroup[key], a => getYear(a.sampleDate))
            return keys(yearGroup).map(year => {
                const analysis = yearGroup[year].map(a => ({ ...a, ...calculateThresholdsResult(a, []) }))
                const quantifiedAnalysis = analysis.filter(a => a.remark === REMARK_CODES.VALID)
                const listSumPesticideAnalysis = listSumPesticides.length ? quantifiedAnalysis.filter(a => listSumPesticides.includes(a.parameter)) : quantifiedAnalysis
                const total = sumBy(listSumPesticideAnalysis, 'result')
                const maxAnalyse = searchMaxAnalysis(quantifiedAnalysis) ?? {}
                const {
                    result: resultMax,
                    parameter,
                } = maxAnalyse
                const substance = getLabel(parameters, parameter)
                const nbOperation = uniqBy(analysis, 'operation').length
                const groupQuantifiedAnalysis = groupBy(quantifiedAnalysis, 'parameter')
                const maxAverageTest = max(keys(groupQuantifiedAnalysis).map(paramCode => sumBy(groupQuantifiedAnalysis[paramCode], 'result') / uniqBy(groupQuantifiedAnalysis[paramCode], a => `${a.qualitometer}#${a.operation}`).length))

                const listSumByOperation = groupBy(listSumPesticideAnalysis, 'operation')
                const listSum = keys(listSumByOperation).map(ope => sumBy(listSumByOperation[ope], 'result'))
                const averageSumPesticide = listSum.length > 0 ? mean(listSum) : undefined
                const maxSumPesticides = max(listSum)

                return {
                    catchmentPoint: { value: stationName },
                    year: { value: year },
                    total: { value: isUndefined(total) ? undefined : round(total, 5), align: ALIGN.RIGHT },
                    nbOperations: { value: nbOperation, align: ALIGN.RIGHT },
                    nbAnalysisPesticides: { value: analysis.length, align: ALIGN.RIGHT },
                    nbQuantificationsPesticides: { value: quantifiedAnalysis.length, align: ALIGN.RIGHT },
                    max: {
                        value: resultMax,
                        align: ALIGN.RIGHT,
                        color: getThresholdColor(resultMax, threshold1, threshold2),
                        ...getTooltip(substance, maxAnalyse, threshold1, threshold2, showSandreCode),
                    },
                    substanceMax: { value: substance },
                    annualAverageTotalPesticides: { value: isUndefined(averageSumPesticide) ? undefined: round(averageSumPesticide, 5), align: ALIGN.RIGHT },
                    maxSumPesticides: { value: isUndefined(maxSumPesticides) ? undefined: round(maxSumPesticides, 5), align: ALIGN.RIGHT },
                    annualAverageMax: { value: isUndefined(maxAverageTest) ? undefined: round(maxAverageTest, 4), align: ALIGN.RIGHT },
                }
            })
        })
        return orderBy(flatten(formated), ['catchmentPoint.value', 'year.value'], ['asc', 'desc'])
    }, [cities, parameters, pesticidesAnalysisGroup, qualitometers, threshold1, threshold2, listSumPesticides, showSandreCode])

    const exportAction = useMemo(() => ([{
        icon: 'file_download',
        tooltip: i18n.export,
        onClick: () => {
            const formated = keys(pesticidesAnalysisGroup).map(key => {
                const qualitometer = qualitometers.find(q => q.id === parseInt(key))
                const city = qualitometer && cities.find(c => c.code === qualitometer.townCode)
                const yearGroup = groupBy(pesticidesAnalysisGroup[key], a => getYear(a.sampleDate))
                return keys(yearGroup).map(year => {
                    const analysis = yearGroup[year].map(a => ({ ...a, ...calculateThresholdsResult(a, []) }))
                    const quantifiedAnalysis = analysis.filter(a => a.remark === REMARK_CODES.VALID)
                    const listSumPesticideAnalysis = listSumPesticides.length ? quantifiedAnalysis.filter(a => listSumPesticides.includes(a.parameter)) : quantifiedAnalysis
                    const total = sumBy(listSumPesticideAnalysis, 'result')
                    const maxAnalyse = searchMaxAnalysis(quantifiedAnalysis) ?? {}
                    const {
                        result: resultMax,
                        parameter,
                    } = maxAnalyse
                    const nbOperation = uniqBy(analysis, 'operation').length
                    const groupQuantifiedAnalysis = groupBy(quantifiedAnalysis, 'parameter')
                    const maxAverageTest = max(keys(groupQuantifiedAnalysis).map(paramCode => sumBy(groupQuantifiedAnalysis[paramCode], 'result') / uniqBy(groupQuantifiedAnalysis[paramCode], a => `${a.qualitometer}#${a.operation}`).length))

                    const listSumByOperation = groupBy(listSumPesticideAnalysis, 'operation')
                    const listSum = keys(listSumByOperation).map(ope => sumBy(listSumByOperation[ope], 'result'))
                    const averageSumPesticide = listSum.length > 0 ? mean(listSum) : undefined
                    const maxSumPesticides = max(listSum)

                    return {
                        code: { value: qualitometer?.code, cellType: 'string' },
                        catchmentPoint: qualitometer?.name,
                        cityCode: city?.code,
                        cityLabel: city?.name,
                        year: { value: year, format: 'yyyy', cellType: 'date' },
                        total: { value: isUndefined(total) ? undefined : round(total, 5), format: '0.0000', cellType: 'number' },
                        nbOperations: { value: nbOperation, format: '0', cellType: 'number' },
                        nbAnalysisPesticides: { value: analysis.length, align: ALIGN.RIGHT },
                        nbQuantifications: { value: quantifiedAnalysis.length, format: '0', cellType: 'number' },
                        max: { value: resultMax, format: '0.0000', cellType: 'number' },
                        substanceMax: getLabel(parameters, parameter, 'name'),
                        annualAverageTotalPesticides: { value: isUndefined(averageSumPesticide) ? undefined: round(averageSumPesticide, 5), format: '0.00000', cellType: 'number' },
                        maxSumPesticides: { value: isUndefined(maxSumPesticides) ? undefined: round(maxSumPesticides, 5), align: ALIGN.RIGHT },
                        annualAverageMax: { value: isUndefined(maxAverageTest) ? undefined: round(maxAverageTest, 4), cellType: 'right' },

                    }
                })
            })
            const dataOrdered = orderBy(flatten(formated), ['code.value', 'year.value'], ['asc', 'desc'])
            const data = dataOrdered.length ? [{ ...dataOrdered[0], headers: keys(dataOrdered[0]) }, ...dataOrdered.slice(1)] : []
            exportFile({
                data,
                exportType: 'xlsx',
                titleFile: i18n.pesticidesFollowUp,
            })
        },
    }]), [pesticidesAnalysisGroup, qualitometers, cities, listSumPesticides, parameters])

    return (
        <>
            <CardTable
                title={i18n.pesticidesConcentrationStatistics}
                rows={analysisFormated}
                headers={[
                    { key: 'catchmentPoint', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.catchmentPoint}</span>) },
                    'year',
                    'total',
                    { key: 'nbOperations', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbOperations}</span>) },
                    { key: 'nbAnalysisPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbAnalysisPesticides}</span>) },
                    { key: 'nbQuantificationsPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbQuantificationsPesticides}</span>) },
                    'max',
                    { key: 'substanceMax', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.substanceMax}</span>) },
                    { key: 'annualAverageTotalPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.annualAverageTotalPesticides}</span>) },
                    { key: 'maxSumPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.maxSumPesticides}</span>) },
                    { key: 'annualAverageMax', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.annualAverageMax}</span>) },
                ]}
                actions={exportAction}
                rowsPerPageOptions={nbPerPageLabel}
                maxHeight={275}
                hideNbElements
                centerTitle
            />
        </>
    )
}

FollowUpPesticidesTable.propTypes = {
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    listSumPesticides: PropTypes.arrayOf(PropTypes.string),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
}

const EXPORT_ALL_STATS_HEADERS = [
    'code',
    'name',
    'cityCode',
    'cityLabel',
    'nbAnalysis',
    'exportMax',
    'exportPercentile90',
    'trend',
    'sageThresholdPesticides',
    'exceedingFrequencyPesticides',
    'exceedingNbPesticides',
    'sageThresholdSumPesticides',
    'exceedingFrequencySumPesticides',
    'exceedingNbSumPesticides',
    'maxAnnualSumPesticidesFromLabo',
    'quantificationsPercent',
    'distinctQuantificationsNb',
    'threshold1OverrunsNb',
    'threshold1OverrunsFrequency',
    'threshold2OverrunsNb',
    'threshold2OverrunsFrequency',
    'threshold3OverrunsNb',
    'threshold3OverrunsFrequency',
    'threshold4OverrunsNb',
    'threshold4OverrunsFrequency',
    'exceedingYears',
]
const EXPORT_NO_STATS_INSEE_CODE = [
    'code',
    'name',
    'cityLabel',
    'nbAnalysis',
    'exportMax',
    'exportPercentile90',
    'trend',
    'sageThresholdPesticides',
    'exceedingFrequencyPesticides',
    'exceedingNbPesticides',
    'sageThresholdSumPesticides',
    'exceedingFrequencySumPesticides',
    'exceedingNbSumPesticides',
    'maxAnnualSumPesticidesFromLabo',
    'quantificationsPercent',
    'distinctQuantificationsNb',
    'threshold1OverrunsNb',
    'threshold1OverrunsFrequency',
    'threshold2OverrunsNb',
    'threshold2OverrunsFrequency',
    'threshold3OverrunsNb',
    'threshold3OverrunsFrequency',
    'threshold4OverrunsNb',
    'threshold4OverrunsFrequency',
    'exceedingYears',
]

const StatisticsPesticidesTable = ({
    pesticidesAnalysis = [],
    sumPesticidesLaboAnalysis = [],
    sumPesticidesAnalysis = [],
    endPeriod,
}) => {
    const {
        catchment,
        qualitometers,
        parameters,
        qualityThresholds,
        cities,
    } = useSelector(store => ({
        catchment: store.CatchmentReducer.catchment,
        qualitometers: store.QualityReducer.qualitometersLight,
        parameters: store.ParameterReducer.parameters,
        qualityThresholds: store.QualityReducer.qualityThresholds,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const specificThreshold = useApplicationSetting('CATCHMENT_SPECIFIC_THRESHOLD')
    const threshold = useMemo(() => qualityThresholds.find(t => t.thresholdCode === specificThreshold && t.thresholdType === THRESHOLD.PC), [qualityThresholds, specificThreshold])
    const thresholdsIndexed = useMemo(() => keyBy(threshold?.thresholds ?? [], 'parameterCode'), [threshold?.thresholds])

    const threshold1 = useApplicationSetting(THRESHOLD_S1, setting => setting ? parseFloat(setting) : undefined)
    const threshold2 = useApplicationSetting(THRESHOLD_S2, setting => setting ? parseFloat(setting) : undefined)
    const threshold3 = useApplicationSetting(THRESHOLD_S3, setting => setting ? parseFloat(setting) : undefined)
    const threshold4 = useApplicationSetting(THRESHOLD_S4, setting => setting ? parseFloat(setting) : undefined)

    const thresholdPesticides1 = useApplicationSetting('CATCHMENT_PESTICIDE_THRESHOLD_1', setting => setting ? parseFloat(setting) : DEFAULT_THRESHOLD_PESTICIDES_1)
    const thresholdPesticides2 = useApplicationSetting('CATCHMENT_PESTICIDE_THRESHOLD_2', setting => setting ? parseFloat(setting) : DEFAULT_THRESHOLD_PESTICIDES_2)

    const tenYearsAgo = getBeginingOfTheYear(getYear(endPeriod) - 10 + 1)
    const fiveYearsAgo = getBeginingOfTheYear(getYear(endPeriod) - 5 + 1)
    const threeYearsAgo = getBeginingOfTheYear(getYear(endPeriod) - 3 + 1)

    const tenLastYearsAnalysis = pesticidesAnalysis.filter(a => a.sampleDate >= tenYearsAgo)
    const formattedAnalysis = tenLastYearsAnalysis.filter(a => a.remark === REMARK_CODES.VALID).map(a => ({ ...a, ...calculateThresholdsResult(a, []) }))
    const fiveYearsAnalysisGroup = useMemo(() => groupBy(formattedAnalysis.filter(a => a.sampleDate > fiveYearsAgo), STATION_TYPE_NAME.qualitometer), [formattedAnalysis, fiveYearsAgo])
    const comparisonAnalysisGroup = groupBy(tenLastYearsAnalysis.filter(a => a.sampleDate > fiveYearsAgo), STATION_TYPE_NAME.qualitometer)

    const formattedAnalysisLabo = sumPesticidesLaboAnalysis.filter(a => a.sampleDate >= tenYearsAgo && a.remark === REMARK_CODES.VALID).map(a => ({ ...a, ...calculateThresholdsResult(a, []) }))
    const fiveLastYearsAnalysisLabo = formattedAnalysisLabo.filter(a => a.sampleDate > fiveYearsAgo)
    const fiveYearsAnalysisGroupLabo = useMemo(() => groupBy(fiveLastYearsAnalysisLabo, STATION_TYPE_NAME.qualitometer), [fiveLastYearsAnalysisLabo])

    const formattedSumAnalysis = sumPesticidesAnalysis.filter(a => a.sampleDate >= tenYearsAgo).map(a => ({ ...a, ...calculateThresholdsResult(a, []) }))
    const fiveYearsSumAnalysisGroup = useMemo(() => groupBy(formattedSumAnalysis.filter(a => a.sampleDate > fiveYearsAgo), STATION_TYPE_NAME.qualitometer), [formattedSumAnalysis, fiveYearsAgo])
    const referenceSumAnalysisGroup = useMemo(() => groupBy(formattedSumAnalysis.filter(a => fiveYearsAgo > a.sampleDate), STATION_TYPE_NAME.qualitometer), [formattedSumAnalysis, fiveYearsAgo])
    const threeYearsSumAnalysisGroup = useMemo(() => groupBy(formattedSumAnalysis.filter(a => a.sampleDate > threeYearsAgo), STATION_TYPE_NAME.qualitometer), [formattedSumAnalysis, threeYearsAgo])

    const sageThresholdPesticides = catchment?.sageThresholdPesticides ?? thresholdPesticides1
    const sageThresholdSumPesticides = catchment?.sageThresholdSumPesticides ?? thresholdPesticides2

    const getAverageTooltip = (result, code, firstThreshold, secondThreshold, showCode = true) => {
        if (!result || !code) return {}
        return {
            tooltip: (
                <SliderPanel
                    title={`${i18n.pesticides}`}
                    analysis={{ result }}
                    threshold={{
                        parameterCode: showCode ? code : undefined,
                        threshold1: firstThreshold,
                        threshold2: secondThreshold,
                        thresholdType: THRESHOLD_TYPE.INCREASING,
                        display: THRESHOLD_DISPLAY.INCREASING,
                        discriminant: THRESHOLD_DISCRIMINANT.SUP_OR_EQUAL,
                    }}
                    withThresholdLevels
                    overrideColors={[THRESHOLD_COLOR.green, THRESHOLD_COLOR.orange, THRESHOLD_COLOR.red]}
                />
            ),
        }
    }

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)
    const generalShowInseeCode = useApplicationSetting(SHOW_INSEE_CODE, setting => setting ? parseInt(setting) : true)
    const showInseeCode = useAccountSetting(SHOW_INSEE_CODE, setting => setting ? parseInt(setting) : generalShowInseeCode)

    const analysisFormated = useMemo(() => {
        const formated = keys(fiveYearsAnalysisGroup).map(key => {
            const qualitometer = qualitometers.find(q => q.id === parseInt(key))
            const city = qualitometer && cities.find(c => c.code === qualitometer.townCode)
            const stationName = [qualitometer?.code ? `[${qualitometer.code}]` : '', `${qualitometer?.name || ''}`, `${city?.name ? `- ${city.name}` : ''}`].join(' ')

            const nbAnalysis = fiveYearsAnalysisGroup[key].length
            const maxValue = searchMaxAnalysis(threeYearsSumAnalysisGroup[key])
            const substance = getLabel(parameters, maxValue?.parameter)
            const p90 = searchP90Analysis(threeYearsSumAnalysisGroup[key])?.result

            const referenceAverage = calculateAverage(referenceSumAnalysisGroup[key])
            const fiveLastYearsAverage = calculateAverage(fiveYearsSumAnalysisGroup[key])
            const evolutionPercent = referenceAverage ? round(fiveLastYearsAverage / referenceAverage * 100 -100, 2) : undefined
            const trend = evolutionPercent ? evolutionPercent >= 5 ? i18n.rise : evolutionPercent <= -5 ? i18n.decrease : i18n.stable : i18n.noDataEnough

            const exceedingPesticidesAnalysis = fiveYearsAnalysisGroup[key].filter(a => a.result > sageThresholdPesticides)
            const nbExceedingPesticidesAnalysis = exceedingPesticidesAnalysis.length
            const totalPesticidesAnalysis = fiveYearsAnalysisGroup[key].length
            const exceedingPesticidesFrequency = totalPesticidesAnalysis > 0 ? round(nbExceedingPesticidesAnalysis / totalPesticidesAnalysis * 100, 2) : 0

            const exceedingSumPesticidesAnalysis = fiveYearsSumAnalysisGroup[key]?.filter(a => a.result > sageThresholdSumPesticides) ?? []
            const nbExceedingSumPesticidesAnalysis = exceedingSumPesticidesAnalysis.length
            const totalSumPesticidesAnalysis = fiveYearsSumAnalysisGroup[key]?.length ?? 0
            const exceedingSumPesticidesFrequency = totalSumPesticidesAnalysis > 0 ? round(nbExceedingSumPesticidesAnalysis / totalSumPesticidesAnalysis * 100, 2) : 0

            const maxAnnualSumPesticidesFromLabo = maxBy(fiveYearsAnalysisGroupLabo[key], 'result')?.result
            const quantificationsPercent = comparisonAnalysisGroup[key]?.length > 0 ? round(fiveYearsAnalysisGroup[key].length / comparisonAnalysisGroup[key].length * 100, 2) : 0
            const distinctQuantificationsNb = keys(groupBy(fiveYearsAnalysisGroup[key], 'parameter')).length

            const threshold1Overruns = fiveYearsAnalysisGroup[key].filter(a => a.result > (thresholdsIndexed[a.parameter]?.threshold1 ?? threshold1))
            const threshold2Overruns = isEmpty(thresholdsIndexed) ? fiveYearsSumAnalysisGroup[key]?.filter(a => a.result > threshold2) ?? [] : fiveYearsAnalysisGroup[key].filter(a => a.result > (thresholdsIndexed[a.parameter]?.threshold2 ?? threshold2))
            const threshold3Overruns = fiveYearsAnalysisGroup[key].filter(a => a.result > (thresholdsIndexed[a.parameter]?.threshold3 ?? threshold3))
            const threshold4Overruns = isEmpty(thresholdsIndexed) ? fiveYearsSumAnalysisGroup[key]?.filter(a => a.result > threshold4) ?? [] : fiveYearsAnalysisGroup[key].filter(a => a.result > (thresholdsIndexed[a.parameter]?.threshold4 ?? threshold4))
            const threshold1OverrunsNb = threshold1Overruns.length
            const threshold2OverrunsNb = threshold2Overruns.length
            const threshold3OverrunsNb = threshold3Overruns.length
            const threshold4OverrunsNb = threshold4Overruns.length
            const exceedingYears = uniq([...threshold3Overruns, ...threshold4Overruns].map(a => getYear(a.sampleDate))).sort((a, b) => a - b).reduce((str, year) => `${str} ${year?.toString()}`, '')
            const totalAnalysisReference = isEmpty(thresholdsIndexed) ? totalSumPesticidesAnalysis : totalPesticidesAnalysis

            return {
                code: { value: qualitometer?.code, cellType: 'string' },
                name: qualitometer?.name,
                cityCode: city?.code,
                cityLabel: city?.name,
                catchmentPoint: { value: stationName },
                nbAnalysis: { value: nbAnalysis, align: ALIGN.RIGHT },
                max: {
                    value: maxValue?.value ? round(maxValue?.value, 4) : undefined,
                    align: ALIGN.RIGHT,
                    color: getThresholdColor(maxValue?.result, threshold1, threshold3),
                    ...getTooltip(substance, maxValue, threshold1, threshold3, showSandreCode),
                },
                percentile90: {
                    value: p90 ? round(p90, 4) : undefined,
                    align: ALIGN.RIGHT,
                    color: getThresholdColor(p90, threshold1, threshold3),
                    ... getAverageTooltip(p90, SUM_PESTICIDES_LABO, threshold1, threshold3, showSandreCode),
                },
                exportMax: {
                    value: maxValue?.value ? round(maxValue?.value, 4) : undefined,
                    cellType: 'number',
                },
                exportPercentile90: {
                    value: p90 ? round(p90, 4) : undefined,
                    align: ALIGN.RIGHT,
                    cellType: 'number',
                },
                trend,
                sageThresholdPesticides: { value: sageThresholdPesticides, align: ALIGN.RIGHT, cellType: 'number' },
                exceedingFrequencyPesticides: { value: `${exceedingPesticidesFrequency} %`, align: ALIGN.RIGHT, cellType: 'right' },
                exceedingNbPesticides: { value: nbExceedingPesticidesAnalysis, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                sageThresholdSumPesticides: { value: sageThresholdSumPesticides, align: ALIGN.RIGHT, cellType: 'number' },
                exceedingFrequencySumPesticides: { value: `${exceedingSumPesticidesFrequency} %`, align: ALIGN.RIGHT, cellType: 'right' },
                exceedingNbSumPesticides: { value: nbExceedingSumPesticidesAnalysis, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                maxAnnualSumPesticidesFromLabo: { value: maxAnnualSumPesticidesFromLabo ? round(maxAnnualSumPesticidesFromLabo, 4) : undefined, align: ALIGN.RIGHT, cellType: 'number' },
                quantificationsPercent: { value: `${quantificationsPercent} %`, align: ALIGN.RIGHT, cellType: 'right' },
                distinctQuantificationsNb: { value: distinctQuantificationsNb, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                threshold1OverrunsNb: { value: threshold1OverrunsNb, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                threshold1OverrunsFrequency: { value: totalPesticidesAnalysis > 0 ? `${round(threshold1OverrunsNb / totalPesticidesAnalysis * 100, 2)} %` : '0 %', align: ALIGN.RIGHT, cellType: 'right' },
                threshold2OverrunsNb: { value: threshold2OverrunsNb, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                threshold2OverrunsFrequency: { value: totalAnalysisReference > 0 ? `${round(threshold2OverrunsNb / totalAnalysisReference * 100, 2)} %` : '0 %', align: ALIGN.RIGHT, cellType: 'right' },
                threshold3OverrunsNb: { value: threshold3OverrunsNb, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                threshold3OverrunsFrequency: { value: totalPesticidesAnalysis > 0 ? `${round(threshold3OverrunsNb / totalPesticidesAnalysis * 100, 2)} %` : '0 %', align: ALIGN.RIGHT, cellType: 'right' },
                threshold4OverrunsNb: { value: threshold4OverrunsNb, align: ALIGN.RIGHT, cellType: 'number', format: '0' },
                threshold4OverrunsFrequency: { value: totalAnalysisReference > 0 ? `${round(threshold4OverrunsNb / totalAnalysisReference * 100, 2)} %` : '0 %', align: ALIGN.RIGHT, cellType: 'right' },
                exceedingYears: { value: exceedingYears, align: ALIGN.RIGHT, cellType: 'string' },
            }
        })
        return orderBy(flatten(formated), ['catchmentPoint.value'], ['asc'])
    }, [fiveYearsAnalysisGroup, fiveYearsAnalysisGroupLabo, comparisonAnalysisGroup, threeYearsSumAnalysisGroup, fiveYearsSumAnalysisGroup, referenceSumAnalysisGroup, qualitometers, cities, parameters, threshold1, threshold2, threshold3, threshold4, thresholdsIndexed, sageThresholdPesticides, sageThresholdSumPesticides, showSandreCode])

    const exportAction = useMemo(() =>([{
        icon: 'file_download',
        tooltip: i18n.export,
        onClick: () => {
            const thresholdOverrunNb = i18n.thresholdOverrunNb
            const cutThresholdOverrunNb = thresholdOverrunNb.split('${ threshold }')[0]
            const thresholdOverrunTx = i18n.thresholdOverrunTx
            const cutThresholdOverrunTx = thresholdOverrunTx.split('${ threshold }')[0]
            const overrunYears = i18n.overrunYears

            const dataOrdered = orderBy(flatten(analysisFormated), ['code.value'], ['asc'])
            const data = [{
                ...dataOrdered[0],
                headers: showInseeCode ? EXPORT_ALL_STATS_HEADERS : EXPORT_NO_STATS_INSEE_CODE,
                customHeaders: compact([
                    'code',
                    'name',
                    showInseeCode ? 'cityCode' : '',
                    'cityLabel',
                    'nbQuantifications',
                    'threeLastYearsMax',
                    'threeLastYearsAveragePercentile90',
                    'fiveLastYearsTrend',
                    `${i18n.sageObjective} ${i18n.pesticides}`,
                    `${i18n.overrunTx} ${i18n.pesticides}`,
                    `${i18n.overrunNb} ${i18n.pesticides}`,
                    `${i18n.sageObjective} ${i18n.sumPest}`,
                    `${i18n.overrunTx} ${i18n.sumPest}`,
                    `${i18n.overrunNb} ${i18n.sumPest}`,
                    'maxAnnualSumPesticidesFromLabo',
                    'percentOfQuantifications',
                    'nbSubstancesQuantified',
                    `${cutThresholdOverrunNb} S1`,
                    `${cutThresholdOverrunTx} S1`,
                    `${cutThresholdOverrunNb} S2`,
                    `${cutThresholdOverrunTx} S2`,
                    `${cutThresholdOverrunNb} S3`,
                    `${cutThresholdOverrunTx} S3`,
                    `${cutThresholdOverrunNb} S4`,
                    `${cutThresholdOverrunTx} S4`,
                    `${overrunYears} S3 / S4`,
                ]),
            },
            ...dataOrdered.slice(1),
            ]

            exportFile({
                data,
                exportType: 'xlsx',
                titleFile: i18n.fiveLastYearsStatistics,
            })
        },
    }]), [analysisFormated, showInseeCode])

    return (
        <>
            <CardTable
                title={i18n.fiveLastYearsStatistics}
                rows={analysisFormated}
                headers={[
                    { key: 'catchmentPoint', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.catchmentPoint}</span>) },
                    { key: 'nbAnalysis', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbQuantifications}</span>) },
                    { key: 'max', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.threeLastYearsMax}</span>) },
                    { key: 'percentile90', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.threeLastYearsAveragePercentile90}</span>) },
                    { key: 'trend', value: (
                        <Tooltip title={i18n.fiveLastYearsTrendExplanation}>
                            <span style={{ whiteSpace: 'pre-wrap' }}>{i18n.fiveLastYearsTrend}</span>
                        </Tooltip>
                    ) },
                    { key: 'sageThresholdPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.sageObjective} ${i18n.pesticides}`}</span>) },
                    { key: 'exceedingFrequencyPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.overrunTx} ${i18n.pesticides}`}</span>) },
                    { key: 'exceedingNbPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.overrunNb} ${i18n.pesticides}`}</span>) },
                    { key: 'sageThresholdSumPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.sageObjective} ${i18n.sumPest}`}</span>) },
                    { key: 'exceedingFrequencySumPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.overrunTx} ${i18n.sumPest}`}</span>) },
                    { key: 'exceedingNbSumPesticides', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.overrunNb} ${i18n.sumPest}`}</span>) },
                    { key: 'maxAnnualSumPesticidesFromLabo', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.maxAnnualSumPesticidesFromLabo}</span>) },
                    { key: 'quantificationsPercent', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.percentOfQuantifications}</span>) },
                    { key: 'distinctQuantificationsNb', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbSubstancesQuantified}</span>) },
                    { key: 'threshold1OverrunsNb', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunNb)({ threshold: 'S1' })}</span>) },
                    { key: 'threshold1OverrunsFrequency', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunTx)({ threshold: 'S1' })}</span>) },
                    { key: 'threshold2OverrunsNb', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunNb)({ threshold: 'S2' })}</span>) },
                    { key: 'threshold2OverrunsFrequency', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunTx)({ threshold: 'S2' })}</span>) },
                    { key: 'threshold3OverrunsNb', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunNb)({ threshold: 'S3' })}</span>) },
                    { key: 'threshold3OverrunsFrequency', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunTx)({ threshold: 'S3' })}</span>) },
                    { key: 'threshold4OverrunsNb', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunNb)({ threshold: 'S4' })}</span>) },
                    { key: 'threshold4OverrunsFrequency', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{template(i18n.thresholdOverrunTx)({ threshold: 'S4' })}</span>) },
                    { key: 'exceedingYears', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{`${i18n.overrunYears} S3 / S4`}</span>) },
                ]}
                actions={exportAction}
                rowsPerPageOptions={nbPerPageLabel}
                maxHeight={275}
                hideNbElements
                centerTitle
            />
        </>
    )
}

StatisticsPesticidesTable.propTypes = {
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    sumPesticidesLaboAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    sumPesticidesAnalysis: PropTypes.arrayOf(PropTypes.shape({
        result: PropTypes.number,
        sampleDate: PropTypes.number,
        qualitometer: PropTypes.number,
        parameter: PropTypes.string,
    })),
    endPeriod: PropTypes.number,
}

const FollowUpPesticidesChart = ({
    pesticidesAnalysis = [],
    qualitometersFiltered = [],
    stations,
    threshold1,
    threshold2,
    startPeriod,
    endPeriod,
    openPopin = () => {},
}) => {
    const {
        parameters,
        units,
        qualitometers,
    } = useSelector(store => ({
        parameters: store.ParameterReducer.parameters,
        units: store.UnitReducer.units,
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const analysisFormated = useMemo(() => {
        const filteredPesticidesAnalysis = pesticidesAnalysis.filter(a => a.remark === REMARK_CODES.VALID)
        const groupByQualitometer = groupBy(filteredPesticidesAnalysis, STATION_TYPE_NAME.qualitometer)
        return keys(groupByQualitometer).flatMap(id => {
            const group = groupBy(groupByQualitometer[id], 'parameter')
            const qualitometer = qualitometers.find(q => q.id === groupByQualitometer[id][0].qualitometer)
            return keys(group).map(param => {
                const name = `${stations.length !== 1 ? `${qualitometer?.code} - ` : ''}${getLabel(parameters, param)}`
                return {
                    name,
                    dataList: group[param].map(analyse => ({ date: analyse.sampleDate, value: analyse.result })),
                    unit: getLabel(units, group[param].find(a => a.unit)?.unit, 'symbol'),
                }
            })
        })
    }, [pesticidesAnalysis, qualitometers, stations, parameters, units])

    const myToolActions = qualitometersFiltered.length > 1 ? { title: i18n.filterResult, svg: filterIcon, action: openPopin } : undefined

    return (
        <QualityChart
            title={i18n.pesticidesMonitoring}
            exportName={i18n.pesticidesFollowUp}
            grids={[{ height: 300 }]}
            xAxis={[{ min: startPeriod, max: endPeriod }]}
            yAxis={[{ name: `${i18n.substanceContents} (µg/L)`, min: 0 }]}
            series={analysisFormated}
            thresholds={[{ dataList: [{ value: threshold1 }, { value: threshold2 }].filter(t => !isUndefined(t.value)) }]}

            withToolQuantification
            withToolTypeLine
            withToolTypeBar
            withToolTypeStack
            withToolLog
            withToolThreshold
            withToolMarker
            withToolLine
            withToolActions={compact([myToolActions])}
            withToolFullScreen
            withToolZoom='FOLLOW_UP_PESTICIDES_CHART'
        />
    )
}

FollowUpPesticidesChart.propTypes = {
    startPeriod: PropTypes.number,
    endPeriod: PropTypes.number,
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    qualitometersFiltered: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number,
    })),
    stations: PropTypes.arrayOf(PropTypes.number),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
    openPopin: PropTypes.func,
}

const SumPesticidesChart = ({
    sumAnalysis = [],
    sumAnalysisLabo = [],
    qualitometersFiltered = [],
    selectedTrend,
    trendsMannKendall = [],
    trendsRupture = [],
    threshold1,
    threshold2,
    startPeriod,
    endPeriod,
    openPopin = () => {},
}) => {
    const {
        qualitometers,
        cities,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const analysisGroup = useMemo(() => groupBy(sumAnalysis, STATION_TYPE_NAME.qualitometer), [sumAnalysis])

    const analysisFormated = useMemo(() => keys(analysisGroup).map(key => {
        const { qualitometer: qualitometerId } = analysisGroup[key][0]
        const qualito = qualitometers.find(q => q.id === qualitometerId)
        const city = qualito && cities.find(c => c.code === qualito.townCode)
        return {
            idStation: qualitometerId,
            name: [qualito.code ? `[${qualito.code}]` : '', `${qualito.name || ''}`, `${city?.name ? `- ${city.name}` : ''}`].join(' '),
            unit: 'μg/L',
            dataList: analysisGroup[key].map(analyse => ({ date: analyse.sampleDate, value: analyse.result })),
        }
    }), [analysisGroup, qualitometers, cities])

    const laboAnalysisFormated = useMemo(() => {
        if (sumAnalysisLabo.length === 0) return []
        return [{
            idStation: sumAnalysisLabo[0].qualitometer,
            name: i18n.sumPesticidesFromLabo,
            unit: 'μg/L',
            dataList: sumAnalysisLabo.map(analyse => ({ date: analyse.sampleDate, value: analyse.result })),
            color: ColorConstant.BLUE,
        }]
    }, [sumAnalysisLabo])

    const hypeFormated = useMemo(() => {
        const minDate = minBy(sumAnalysis, 'sampleDate')?.sampleDate
        const maxDate = maxBy(sumAnalysis, 'sampleDate')?.sampleDate

        const qualitometer = qualitometers.find(q => q.id === selectedTrend)
        const trendMannKendall = qualitometer ? trendsMannKendall.find(t => qualitometer.code === t.stationCode) : undefined
        const trendRupture = qualitometer ? trendsRupture.find(t => qualitometer.code === t.stationCode) : undefined

        const mannKendallTrend = trendMannKendall && qualitometer?.id === selectedTrend ? [{
            name: i18n.mannKendallTrend,
            showSymbol: false,
            dataList: formatHypeTrend(trendMannKendall.coefficient, trendMannKendall.value, minDate, maxDate),
        }] : []

        if (trendRupture && (['preValue', 'preCoefficient', 'breakDate'].every(k => hasValue(trendRupture[k])) || ['postValue', 'postCoefficient', 'breakDate'].every(k => hasValue(trendRupture[k])))) {
            const maxValue = max([maxBy(sumAnalysis, 'result')?.result || 0, threshold1, threshold2])
            const ruptureLine = {
                name: i18n.trendRupture,
                dataList: [
                    { date: trendRupture.breakDate, value: 1.1 * maxValue },
                    { date: trendRupture.breakDate, value: 0 },
                ],
                lineStyle: 'dashed',
            }
            const rupture = {
                name: i18n.trendRupture,
                connectNulls: false,
                showSymbol: false,
                dataList: formatHypeTrendRupture(trendRupture, minDate, maxDate),
            }
            return [
                ...mannKendallTrend,
                ruptureLine,
                rupture,
            ]
        }

        return mannKendallTrend
    }, [sumAnalysis, threshold1, threshold2, selectedTrend, qualitometers, trendsMannKendall, trendsRupture])

    const myToolActions = qualitometersFiltered.length > 1 ? { title: i18n.filterResult, svg: filterIcon, action: openPopin } : undefined

    return (
        <QualityChart
            exportName={i18n.pesticidesFollowUp}
            grids={[{ height: 225 }]}
            xAxis={[{ min: startPeriod, max: endPeriod }]}
            yAxis={[{ name: `${i18n.sumPesticides} (µg/L)`, min: 0 }]}
            series={[...analysisFormated, ...laboAnalysisFormated, ...hypeFormated]}
            thresholds={[{ dataList: [{ value: threshold1 }, { value: threshold2 }].filter(t => !isUndefined(t.value)) }]}

            withToolQuantification
            withToolTypeLine
            withToolTypeBar
            withToolLog
            withToolThreshold
            withToolMarker
            withToolLine
            withToolActions={compact([myToolActions])}
            withToolFullScreen
            withToolZoom='SUM_PESTICIDES_CHART'
        />
    )
}

SumPesticidesChart.propTypes = {
    sumAnalysis: PropTypes.arrayOf(PropTypes.shape({
        result: PropTypes.number,
        sampleDate: PropTypes.number,
        qualitometer: PropTypes.number,
        parameter: PropTypes.string,
    })),
    sumAnalysisLabo: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    qualitometersFiltered: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number,
    })),
    selectedTrend: PropTypes.number,
    trendsMannKendall: PropTypes.arrayOf(PropTypes.shape({})),
    trendsRupture: PropTypes.arrayOf(PropTypes.shape({})),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
    startPeriod: PropTypes.number,
    endPeriod: PropTypes.number,
    openPopin: PropTypes.func,
}

const HypeTable = ({
    sumAnalysis = [],
    qualitometersFiltered = [],
    selectedTrend,
    setSelectedTrend = () => {},
    trendsMannKendall = [],
    trendsRupture = [],
}) => {
    const {
        qualitometers,
        cities,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        cities: store.CityReducer.cities,
    }), shallowEqual)

    const data = useMemo(() => {
        const groupedAnalysis = groupBy(sumAnalysis, STATION_TYPE_NAME.qualitometer)
        return qualitometersFiltered.map(qualito => {
            const qualitometer = qualitometers.find(q => q.id === qualito.id)
            const { [qualitometer.id]: analysis = [] } = groupedAnalysis
            const trend = trendsMannKendall.find(t => t.stationCode === qualitometer.code)
            const rupture = trendsRupture.find(t => t.stationCode === qualitometer.code)
            const mannKendallTrend = (!hasValue(trend) || trend?.coefficient === 0) && i18n.noTrend || trend.coefficient > 0 && i18n.rise || i18n.decrease
            const city = qualitometer && cities.find(c => c.code === qualitometer.townCode)
            const stationName = [qualitometer?.code ? `[${qualitometer.code}]` : '', `${qualitometer?.name || ''}`, `${city?.name ? `- ${city.name}` : ''}`].join(' ')
            const icon = (
                <Tooltip title={qualito.id === selectedTrend ? i18n.hideTrend : i18n.displayTrend }>
                    <IconButton
                        sx={{ color: blackColor }}
                        size='actionTable'
                        onClick={ () => setSelectedTrend(qualito.id === selectedTrend ? undefined : qualito.id) }
                    >
                        <Icon fontSize='inherit'>{ qualito.id === selectedTrend ? <VisibilityOff /> : <Visibility /> }</Icon>
                    </IconButton>
                </Tooltip>
            )

            return {
                nullValueIconButton: { value: (mannKendallTrend === i18n.noTrend && isUndefined(rupture)) ? <></> : icon },
                catchmentPoint: { value: stationName },
                nbQuantifications: { value: analysis.length },
                mannKendallTrend: { value: (!hasValue(trend) || trend?.coefficient === 0) && i18n.noTrend || trend.coefficient > 0 && i18n.rise || i18n.decrease },
                ruptureDate: { value: rupture?.breakDate ? getDate(rupture.breakDate) : i18n.noRupture },
                id: qualitometer.id,
            }
        })
    }, [qualitometers, qualitometersFiltered, sumAnalysis, trendsMannKendall, trendsRupture, selectedTrend, cities])

    return (
        <NewTable
            rows={data}
            headers={[
                'nullValueIconButton',
                { key: 'catchmentPoint', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.catchmentPoint}</span>) },
                { key: 'nbQuantifications', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbQuantifications}</span>) },
                { key: 'mannKendallTrend', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.mannKendallTrend}</span>) },
                { key: 'ruptureDate', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.ruptureDate}</span>) },
            ]}
            maxHeight={275}
        />
    )
}

HypeTable.propTypes = {
    sumAnalysis: PropTypes.arrayOf(PropTypes.shape({
        result: PropTypes.number,
        sampleDate: PropTypes.number,
        qualitometer: PropTypes.number,
        parameter: PropTypes.string,
    })),
    qualitometersFiltered: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    })),
    selectedTrend: PropTypes.number,
    setSelectedTrend: PropTypes.func,
    trendsMannKendall: PropTypes.arrayOf(PropTypes.shape({})),
    trendsRupture: PropTypes.arrayOf(PropTypes.shape({})),
}

const HypeCardPesticides = ({
    pesticidesAnalysis = [],
    sumAnalysis,
    sumPesticidesLaboAnalysis = [],
    qualitometersFiltered = [],
    stations = [],
    threshold1,
    threshold2,
    startPeriod,
    endPeriod,
    openPopin = () => {},
}) => {
    const dispatch = useDispatch()

    const {
        qualitometers,
        settings,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        settings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    const [trendsMannKendall, setTrendsMannKendall] = useState([])
    const [trendsRupture, setTrendsRupture] = useState([])
    const [selectedTrend, setSelectedTrend] = useState(null)

    const filteredSumAnalysis = useMemo(() => {
        if (stations.length > 0) {
            return sumAnalysis.filter(({ qualitometer }) => stations.includes(qualitometer))
        }
        return sumAnalysis
    }, [stations, sumAnalysis])

    const filteredSumAnalysisLabo = useMemo(() => {
        if (stations.length === 1) {
            return sumPesticidesLaboAnalysis.filter(({ qualitometer }) => stations.includes(qualitometer))
        }
        if (qualitometersFiltered.length === 1) return sumPesticidesLaboAnalysis
        return []
    }, [stations, sumPesticidesLaboAnalysis, qualitometersFiltered])

    const firstCatchmentYear = getSettingBool(settings, 'FIRST_CATCHMENT_YEAR')
    const newStartPeriod = useMemo(() => {
        const consideredAnalysis = [...sumAnalysis, ...sumPesticidesLaboAnalysis]
        const calculatedStartPeriod = (consideredAnalysis.length && firstCatchmentYear) ? getBeginingOfTheYear(getDate(minBy(consideredAnalysis, 'sampleDate').sampleDate, 'YYYY')) : undefined
        return calculatedStartPeriod > startPeriod ? calculatedStartPeriod : startPeriod
    }, [firstCatchmentYear, sumAnalysis, startPeriod, sumPesticidesLaboAnalysis])

    useEffect(() => {
        if (!pesticidesAnalysis.length) {
            return
        }
        const groupedAnalysis = groupBy(sumAnalysis, STATION_TYPE_NAME.qualitometer)
        qualitometersFiltered.forEach(({ id }) => {
            const qualitometer = qualitometers.find(q => q.id === id)
            if (!qualitometer) {
                return
            }
            const { [id]: analysis = [] } = groupedAnalysis

            const hypeData = analysis.map((a, index) => ({
                stationCode: qualitometer.code,
                stationTypeCode: qualitometer.stationType,
                parameterCode: 0,
                analysisNumber: index,
                measureDate: a.sampleDate,
                measure: a.result,
                unitCode: 0,
                remarkCode: 1,
            }))
            if (hypeData.length) {
                dispatch(IAEauAction.getHypeTrend(hypeData, qualitometer.code)).then(({ trends, breaks }) => {
                    const trendMannKendall = trends.filter(t => t.statisticsType === HYPE_TRENDS_CONSTANTS.MANN_KENDALL)
                    const trendRupture = breaks.filter(t => t.statisticsType === HYPE_TRENDS_CONSTANTS.TREND_RUPTURE)
                    setTrendsMannKendall(p => uniqBy([...trendMannKendall, ...p], 'stationCode'))
                    setTrendsRupture(p => uniqBy([...trendRupture, ...p], 'stationCode'))
                })
            }
        })
    }, [dispatch, pesticidesAnalysis.length, qualitometers, qualitometersFiltered, sumAnalysis])

    return (
        <Card sx={{ borderRadius: '0 0 10px 10px', margin: '20px 30px' }}>
            <CardTitle title={i18n.pesticidesTrendsConcentration} centerTitle />
            <CardContent>
                <Grid container>
                    <Grid size={6}>
                        <SumPesticidesChart
                            startPeriod={newStartPeriod}
                            endPeriod={endPeriod}
                            sumAnalysis={filteredSumAnalysis}
                            sumAnalysisLabo={filteredSumAnalysisLabo}
                            qualitometersFiltered={qualitometersFiltered}
                            selectedTrend={selectedTrend}
                            trendsMannKendall={trendsMannKendall}
                            trendsRupture={trendsRupture}
                            threshold1={threshold1}
                            threshold2={threshold2}
                            openPopin={openPopin}
                        />
                    </Grid>
                    <Grid size={6}>
                        <HypeTable
                            sumAnalysis={sumAnalysis}
                            qualitometersFiltered={qualitometersFiltered}
                            selectedTrend={selectedTrend}
                            setSelectedTrend={setSelectedTrend}
                            trendsMannKendall={trendsMannKendall}
                            trendsRupture={trendsRupture}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>

    )
}

HypeCardPesticides.propTypes = {
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    sumAnalysis: PropTypes.arrayOf(PropTypes.shape({
        result: PropTypes.number,
        sampleDate: PropTypes.number,
        qualitometer: PropTypes.number,
        parameter: PropTypes.string,
    })),
    sumPesticidesLaboAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    qualitometersFiltered: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    })),
    stations: PropTypes.arrayOf(PropTypes.number),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
    startPeriod: PropTypes.number,
    endPeriod: PropTypes.number,
    openPopin: PropTypes.func,
}

const FormatObjectiveChart = ({
    qualitometers = [],
    pesticidesAnalysis = [],
    sumPesticidesAnalysis = [],
    threshold1,
    threshold2,
    specificThresholds = [],
    pesticidesStartPeriod,
    sumPesticidesStartPeriod,
    endPeriod,
}) => {
    const {
        catchment,
    } = useSelector(store => ({
        catchment: store.CatchmentReducer.catchment,
    }), shallowEqual)

    const thresholdsIndexed = useMemo(() => keyBy(specificThresholds ?? [], 'parameterCode'), [specificThresholds])
    const globalObjectiveSumPesticides = useApplicationSetting('PESTICIDES_SUM_OBJECTIVE', setting => setting ? parseFloat(setting) : DEFAULT_OBJECTIVE)
    const globalObjectivePesticides = useApplicationSetting('PESTICIDES_OBJECTIVE', setting => setting ? parseFloat(setting) : DEFAULT_OBJECTIVE)
    const objectiveSumPesticides = useMemo(() => catchment.objectiveSumPesticides ?? globalObjectiveSumPesticides, [catchment.objectiveSumPesticides, globalObjectiveSumPesticides])
    const objectivePesticides = useMemo(() => catchment.objectivePesticides ?? globalObjectivePesticides, [catchment.objectivePesticides, globalObjectivePesticides])

    const qualitometersLinked = useMemo(() => (
        catchment.catchmentPoints?.map(point => qualitometers.find(q => q.code === point.codeWithoutDesignation)).filter(q => !!q) || []
    ), [catchment.catchmentPoints, qualitometers])

    const qualitoCodes = useMemo(() => qualitometersLinked.map(q => q.code), [qualitometersLinked])
    const qualitoStations = useMemo(() => catchment.catchmentPoints?.filter(p => qualitoCodes?.includes(p.codeWithoutDesignation)), [catchment.catchmentPoints, qualitoCodes])
    const catchmentAndQualitoReducted = useMemo(() => ({
        id: catchment.id,
        name: catchment.name,
        code: catchment.code,
        points: qualitoStations?.map(p => ({
            codeWithoutDesignation: p.codeWithoutDesignation,
            mainPoint: p.mainPoint,
            qualito: qualitometers.filter(q => q.code === p.codeWithoutDesignation)?.map(q => ({ id: q.id, townCode: q.townCode, name: q.name })),
        })),
        qualito: catchment.catchmentPoints?.flatMap(p => qualitometers.filter(q => q.code === p.codeWithoutDesignation))?.map(q => q.id),
    }), [catchment, qualitometers, qualitoStations])

    return (
        <>
            <Grid size={6}>
                <ObjectiveChart
                    analysis={sumPesticidesAnalysis}
                    objective={objectiveSumPesticides}
                    threshold={threshold2}
                    catchmentAndQualito={catchmentAndQualitoReducted}
                    fileName={i18n.annualSumPesticidesObjective}
                    title={template(i18n.annualSumPesticidesObjectiveDetails)({ objective: objectiveSumPesticides, threshold: threshold2 })}
                    startPeriod={sumPesticidesStartPeriod}
                    endPeriod={endPeriod}
                />
            </Grid>
            <Grid size={6}>
                <ObjectiveChart
                    analysis={pesticidesAnalysis}
                    objective={objectivePesticides}
                    threshold={threshold1}
                    specificThresholds={thresholdsIndexed}
                    catchmentAndQualito={catchmentAndQualitoReducted}
                    fileName={i18n.annualPesticidesObjective}
                    title={template(i18n.annualPesticidesObjectiveDetails)({ objective: objectivePesticides, threshold: threshold1 })}
                    startPeriod={pesticidesStartPeriod}
                    endPeriod={endPeriod}
                />
            </Grid>
        </>
    )
}

FormatObjectiveChart.propTypes = {
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisLight)),
    sumPesticidesAnalysis: PropTypes.arrayOf(PropTypes.shape({
        result: PropTypes.number,
        sampleDate: PropTypes.number,
        qualitometer: PropTypes.number,
        parameter: PropTypes.string,
    })),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
    specificThresholds: PropTypes.arrayOf(QualityThresholdType),
    pesticidesStartPeriod: PropTypes.number,
    sumPesticidesStartPeriod: PropTypes.number,
    endPeriod: PropTypes.number,
}

const CardFollowUpPesticides = ({
    stationIds,
    startPeriod,
    endPeriod,
    producerExcluded,
    threshold1,
    threshold2,
    specificThresholds,
    pesticides,
    listSumPesticides,
}) => {
    const {
        qualitometers,
        appSettings,
        cities,
        catchment,
    } = useSelector(store => ({
        qualitometers: store.QualityReducer.qualitometersLight,
        appSettings: store.AdministrationReducer.applicationSettings,
        cities: store.CityReducer.cities,
        catchment: store.CatchmentReducer.catchment,
    }), shallowEqual)

    const {
        value: isPopinOpen,
        setTrue: openPopin,
        setFalse: closePopin,
    } = useBoolean(false)

    const thresholdIrrelevantPesticides = useApplicationSetting('CATCHMENT_PESTICIDE_IRRELEVANT_THRESHOLD', setting => setting ? parseFloat(setting) : DEFAULT_THRESHOLD_IRRELEVANT_PESTICIDES)

    const qualitometersFiltered = useMemo(() => {
        const points = stationIds?.map(id => {
            return qualitometers.find(q => q.id === id)
        }).filter(q => !!q) || []
        return points.map(({ code, townCode, name = '', id }) => {
            const city = cities.find(c => c.code === townCode)
            return {
                name: `[${code}] ${name} ${city?.name ? `- ${city.name}` : ''} `,
                id,
            }
        })
    }, [qualitometers, stationIds, cities])

    const [stations, setStations] = useState([])
    const [analysis, setAnalysis] = useState([])

    const { isLoaded } = useProgressDispatch(cancelRef => [
        AnalysisAction.getAnalysis({
            lightMode: true,
            stations: stationIds,
            startDate: startPeriod,
            endDate: endPeriod,
            excludedProducers: producerExcluded,
            parameters: uniq([...pesticides, ...listSumPesticides, SUM_PESTICIDES_LABO]),
            support: '3', // support 'eau'
        }).then(json => !cancelRef.current && setAnalysis(json?.map(j => new DtoAnalysisLight(j)))),
    ], [stationIds])

    const valuableAnalysis = useMemo(() => analysis.filter(({ sampleDate, result }) => hasValue(sampleDate) && hasValue(result)), [analysis])
    const pesticidesAnalysis = useMemo(() => valuableAnalysis.filter(a => pesticides.includes(a.parameter)), [valuableAnalysis, pesticides])
    const quantifiedPesticidesAnalysis = useMemo(() => pesticidesAnalysis.filter(a => a.remark === REMARK_CODES.VALID), [pesticidesAnalysis])
    const pesticidesAnalysisGroup = useMemo(() => groupBy(quantifiedPesticidesAnalysis, STATION_TYPE_NAME.qualitometer), [quantifiedPesticidesAnalysis])
    const filteredPesticidesAnalysis = useMemo(() => stations.length > 0 ? pesticidesAnalysis.filter(a => stations.includes(a.qualitometer)) : pesticidesAnalysis, [stations, pesticidesAnalysis])

    const sumPesticidesAnalysis = useMemo(() => listSumPesticides?.length ? valuableAnalysis.filter(a => a.remark === REMARK_CODES.VALID && listSumPesticides.includes(a.parameter)) : quantifiedPesticidesAnalysis, [listSumPesticides, valuableAnalysis, quantifiedPesticidesAnalysis])
    const sumAnalysis = useMemo(() => {
        const filteredSumPesticidesAnalysis = stations.length > 0 ? sumPesticidesAnalysis.filter(a => stations.includes(a.qualitometer)) : sumPesticidesAnalysis
        const groupByOperation = groupBy(filteredSumPesticidesAnalysis, a => `${a.qualitometer}#${a.operation}`)
        return keys(groupByOperation).map(key => {
            const { [key]: randomName = [] } = groupByOperation
            return {
                result: sumBy(randomName, 'result'),
                sampleDate: randomName[0].sampleDate,
                qualitometer: randomName[0].qualitometer,
                parameter: randomName[0].parameter,
            }
        })
    }, [stations, sumPesticidesAnalysis])

    const sumPesticidesLaboAnalysis = useMemo(() => valuableAnalysis.filter(a => a.parameter === SUM_PESTICIDES_LABO), [valuableAnalysis])

    const firstCatchmentYear = getSettingBool(appSettings, 'FIRST_CATCHMENT_YEAR')
    const newPesticidesStartPeriod = (quantifiedPesticidesAnalysis.length && firstCatchmentYear) ? getBeginingOfTheYear(getDate(minBy(quantifiedPesticidesAnalysis, 'sampleDate').sampleDate, 'YYYY')) : startPeriod
    const newStartPeriod = (sumAnalysis.length && firstCatchmentYear) ? getBeginingOfTheYear(getDate(minBy(sumAnalysis, 'sampleDate').sampleDate, 'YYYY')) : startPeriod

    const pointsFormated = useMemo(() => {
        return qualitometersFiltered.map(point => {
            const qualitometer = qualitometers.find(q => q.id === point.id)
            const qualitoAnalysis = quantifiedPesticidesAnalysis.filter(a => a.qualitometer === point.id)
            const city = qualitometer && cities.find(c => c.code === qualitometer.townCode)
            const stationName = [qualitometer?.code ? `[${qualitometer.code}]` : '', `${qualitometer?.name || ''}`, `${city?.name ? `- ${city.name}` : ''}`].join(' ')
            return {
                catchmentPoint: { value: stationName },
                nbQuantifications: { value: qualitoAnalysis.length },
                id: point.id,
            }
        })
    }, [qualitometers, qualitometersFiltered, cities, quantifiedPesticidesAnalysis])

    return (
        <Card data-cy='follow_up_pesticides'>
            <CardTitle title={i18n.pesticidesFollowUp} />
            <CardContent>
                {!isLoaded && (
                    <ProgressCard indeterminate />
                )}
                {isLoaded && (
                    <>
                        {
                            pesticidesAnalysis.length ? (
                                <>
                                    <FollowUpPesticidesChart
                                        startPeriod={newPesticidesStartPeriod}
                                        endPeriod={endPeriod}
                                        pesticidesAnalysis={filteredPesticidesAnalysis}
                                        qualitometersFiltered={qualitometersFiltered}
                                        stations={stations}
                                        threshold1={threshold1}
                                        threshold2={threshold2}
                                        openPopin={openPopin}
                                    />
                                    <HypeCardPesticides
                                        pesticidesAnalysis={pesticidesAnalysis}
                                        sumAnalysis={sumAnalysis}
                                        sumPesticidesLaboAnalysis={sumPesticidesLaboAnalysis}
                                        qualitometersFiltered={qualitometersFiltered}
                                        stations={stations}
                                        threshold1={threshold1}
                                        threshold2={threshold2}
                                        startPeriod={startPeriod}
                                        endPeriod={endPeriod}
                                        openPopin={openPopin}
                                    />
                                    <Stack spacing={2} sx={{ mx: '30px' }}>
                                        <FollowUpPesticidesTable
                                            pesticidesAnalysis={pesticidesAnalysis}
                                            listSumPesticides={listSumPesticides}
                                            threshold1={threshold1}
                                            threshold2={threshold2}
                                        />
                                        <StatisticsPesticidesTable
                                            pesticidesAnalysis={pesticidesAnalysis}
                                            sumPesticidesLaboAnalysis={sumPesticidesLaboAnalysis}
                                            sumPesticidesAnalysis={sumAnalysis}
                                            endPeriod={endPeriod}
                                        />
                                    </Stack>
                                    <Grid container>
                                        <Grid size={7}>
                                            <FrequencyPesticides
                                                pesticidesAnalysis={filteredPesticidesAnalysis ?? pesticidesAnalysis}
                                                qualitometersFiltered={qualitometersFiltered}
                                                relevantThreshold={threshold1}
                                                irrelevantThreshold={thresholdIrrelevantPesticides}
                                                specificThresholds={specificThresholds}
                                                pesticides={pesticides}
                                                startPeriod={newPesticidesStartPeriod}
                                                endPeriod={endPeriod}
                                            />
                                        </Grid>
                                        <Grid size={5} sx={{ paddingTop: '20px' }}>
                                            <PieFamilyPesticides
                                                ids={stationIds}
                                                filters={{ firstStart: newPesticidesStartPeriod, firstEnd: endPeriod }}
                                                title={i18n.distributionQuantificationsByFamily}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ mx: '8vw' }}>
                                        <RelevanceChart
                                            analysis={sumPesticidesAnalysis}
                                            startPeriod={newStartPeriod}
                                            endPeriod={endPeriod}
                                        />
                                    </Box>
                                    <Grid container alignItems={'center'}>
                                        <Grid size={6}>
                                            <AnnualDistributionGraph
                                                sumPesticidesAnalysis={sumPesticidesAnalysis}
                                                stationIds={stationIds}
                                                startPeriod={newStartPeriod}
                                                endPeriod={endPeriod}
                                                producerExcluded={producerExcluded}
                                            />
                                        </Grid>
                                        <Grid size={6}>
                                            <PesticidesChartAnnualEvolution
                                                analysis={pesticidesAnalysisGroup}
                                                thresholds={[{
                                                    dataList: [{ value: threshold1 }, { value: threshold2 }],
                                                    colorList: [THRESHOLD_COLORS_CODES.GREEN, favOrange, THRESHOLD_COLORS_CODES.RED],
                                                }]}
                                                name={`${i18n.average} ${i18n.sumPesticides}`}
                                                unit='µg/L'
                                                startPeriod={newStartPeriod}
                                                endPeriod={endPeriod}
                                            />
                                        </Grid>
                                        { (catchment && !isEmpty(catchment)) && (
                                            <FormatObjectiveChart
                                                qualitometers={qualitometers}
                                                pesticidesAnalysis={quantifiedPesticidesAnalysis}
                                                sumPesticidesAnalysis={sumAnalysis}
                                                threshold1={threshold1}
                                                threshold2={threshold2}
                                                specificThresholds={specificThresholds}
                                                pesticidesStartPeriod={newPesticidesStartPeriod}
                                                sumPesticidesStartPeriod={newStartPeriod}
                                                endPeriod={endPeriod}
                                            />
                                        )}
                                    </Grid>
                                    <Dialog
                                        maxWidth='lg'
                                        open={isPopinOpen}
                                    >
                                        <DefaultDialogTitle
                                            title={
                                                <Grid container columnSpacing={1}>
                                                    {i18n.selectSamplingPointsToAdd}
                                                    <Tooltip title={i18n.selectNoneOrAll}>
                                                        <HelpRounded />
                                                    </Tooltip>
                                                </Grid>
                                            }
                                            onClose={closePopin}
                                        />
                                        <DialogContent>
                                            <Grid container rowSpacing={0.5} columnSpacing={1}>
                                                <Grid size={12}>
                                                    <NewTable
                                                        headers={[
                                                            { key: 'catchmentPoint', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.catchmentPoint}</span>) },
                                                            { key: 'nbQuantifications', value: (<span style={{ whiteSpace: 'pre-wrap' }}>{i18n.nbQuantifications}</span>) },
                                                        ]}
                                                        rows={pointsFormated}
                                                        lineActions={[{
                                                            icon: ({ id }) => stations.includes(id) ? <CheckBox /> : <CheckBoxOutlineBlank />,
                                                            onClick: ({ id }) => setStations(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]),
                                                        }]}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => setStations([])} variant='outlined'>
                                                {i18n.reinit}
                                            </Button>
                                            <Button onClick={closePopin} variant='contained'>
                                                {i18n.validate}
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </>
                            ) : (
                                <MessageCard>{i18n.noDataToDisplay}</MessageCard>
                            )
                        }
                    </>
                )}
            </CardContent>
        </Card>
    )
}

CardFollowUpPesticides.propTypes = {
    stationIds: PropTypes.arrayOf(PropTypes.number),
    startPeriod: PropTypes.number,
    endPeriod: PropTypes.number,
    producerExcluded: PropTypes.arrayOf(PropTypes.number),
    threshold1: PropTypes.number,
    threshold2: PropTypes.number,
    specificThresholds: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualityThreshold)),
    pesticides: PropTypes.arrayOf(PropTypes.number),
    listSumPesticides: PropTypes.arrayOf(PropTypes.string),
}

export {
    FollowUpPesticidesTable,
    FollowUpPesticidesChart,
    // SumPesticidesChart,
    // HypeTable,
    HypeCardPesticides,
    CardFollowUpPesticides,
}